import { CartItem, DeliveryZone, Address } from '../types';
import storage from '../lib/storage';

export const ADD_ITEM = 'ADD_CART_ITEM';
export function addCartItem(payload: CartItem) {
  return {
    type: ADD_ITEM,
    payload,
  };
}

export const REMOVE_ITEM = 'REMOVE_CART_ITEM';
export function removeCartItem(payload: string) {
  return {
    type: REMOVE_ITEM,
    payload,
  };
}

export const REMOVE_BUSINESS_ITEMS = 'REMOVE_CART_BUSINESS_ITEMS';
export function removeCartBusinessItems(payload: string) {
  return {
    type: REMOVE_BUSINESS_ITEMS,
    payload,
  };
}

export const RESTORE_CART = 'RESTORE_CART';
export function restoreCart() {
  const items = storage.getStoredCart();
  return {
    type: RESTORE_CART,
    payload: items,
  };
}

export const CHANGE_ITEM_DELIVERY_ZONE = 'CHANGE_ITEM_DELIVERY_ZONE';
export function changeItemDeliverZone(business: string, zone: DeliveryZone) {
  return {
    type: CHANGE_ITEM_DELIVERY_ZONE,
    payload: { business, zone },
  };
}

export const CHANGE_ITEM_ADDRESS = 'CHANGE_ITEM_ADDRESS';
export function changeItemAddress(business: string, address: Address) {
  return {
    type: CHANGE_ITEM_ADDRESS,
    payload: { business, address },
  };
}


export const CHANGE_ITEM_NOTE = 'CHANGE_ITEM_NOTE';
export function changeItemNote(business: string, note: string) {
  return {
    type: CHANGE_ITEM_NOTE,
    payload: { business, note },
  };
}
